export const SHOW_EMBED_DIALOG = 'SHOW_EMBED_DIALOG';
export const HIDE_EMBED_DIALOG = 'HIDE_EMBED_DIALOG';

export function showEmbedDialog() {
  return {
    type: SHOW_EMBED_DIALOG,
  }
}

export function hideEmbedDialog() {
  return {
    type: HIDE_EMBED_DIALOG,
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/embed.js